import React from "react";
import { useNavigate } from "react-router-dom";
import "./CartOffcanvas.css"
const CartOffcanvas = ({ cart, removeFromCart }) => {
  const navigate = useNavigate();

  const totalAmount = cart.reduce((total, item) => total + item.price, 0);

  return (
    <div
      className="offcanvas offcanvas-end cart-offcanvas"
      tabIndex="-1"
      id="cartOffcanvas"
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="offcanvas-title">Shopping Cart</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
        ></button>
      </div>

      <div className="offcanvas-body d-flex flex-column justify-content-between">

        {/* CART ITEMS */}
        <div>
          {cart.length === 0 ? (
            <div className="text-center mt-4">
              <h6>Your cart is empty</h6>
            </div>
          ) : (
            cart.map((item, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center border-bottom py-3"
              >
                <div>
                  <h6 className="mb-1">{item.title}</h6>
                  <small>₹ {item.price}</small>
                </div>

                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => removeFromCart(index)}
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            ))
          )}
        </div>

        {/* TOTAL SECTION */}
        {cart.length > 0 && (
          <div className="border-top pt-3">
            <div className="d-flex justify-content-between fw-bold mb-3">
              <span>Total</span>
              <span>₹ {totalAmount}</span>
            </div>

            <button
              className="btn btn-warning w-100"
              onClick={() => navigate("/payment")}
              data-bs-dismiss="offcanvas"
            >
              Checkout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartOffcanvas;